import React from 'react';
import Hero from '../components/Hero';
import { Button } from '../components/ui/button';
import { ArrowRight, Target, Users, BookOpen } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const navigate = useNavigate();

  const highlights = [
    {
      icon: Target,
      title: 'Tailored Solutions',
      description: 'Personalized financial strategies designed for your unique goals.'
    },
    {
      icon: Users,
      title: 'Community Focused',
      description: 'Empowering underserved communities through financial education.'
    },
    {
      icon: BookOpen,
      title: 'Expert Guidance',
      description: 'Professional advice from experienced financial specialists.'
    }
  ];

  return (
    <div>
      <Hero />
      
      {/* Quick Overview Section */}
      <section className="bg-white py-20 px-6 md:px-12">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-serif text-[#0A2540] font-bold mb-6">
              Your Financial Success Partner
            </h2>
            <p className="text-lg text-[#2C3E50] max-w-3xl mx-auto leading-relaxed">
              At Brooks & Associates, we believe in empowering individuals and families 
              with the knowledge and tools needed to achieve financial freedom.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {highlights.map((item, index) => {
              const Icon = item.icon;
              return (
                <div key={index} className="text-center space-y-4 p-6">
                  <div className="flex justify-center">
                    <div className="bg-[#C4E5F4] p-4 rounded-full">
                      <Icon className="h-10 w-10 text-[#0B8FD8]" />
                    </div>
                  </div>
                  <h3 className="text-xl md:text-2xl font-serif text-[#0A2540] font-bold">
                    {item.title}
                  </h3>
                  <p className="text-base text-[#2C3E50] leading-relaxed">
                    {item.description}
                  </p>
                </div>
              );
            })}
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col md:flex-row gap-4 justify-center mt-12">
            <Button 
              className="bg-[#0B8FD8] hover:bg-[#0973B0] text-white px-8 py-3 text-base rounded-md transition-all duration-300 shadow-lg hover:shadow-xl"
              onClick={() => navigate('/services')}
            >
              Explore Our Services
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
            <Button 
              className="bg-white hover:bg-gray-50 text-[#0B8FD8] border-2 border-[#0B8FD8] px-8 py-3 text-base rounded-md transition-all duration-300"
              onClick={() => navigate('/about')}
            >
              Learn More About Us
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
